export default __webpack_public_path__ + "static/media/croissant.0e1a32e0.svg";